import React from "react";
import { MarketingShell } from "@/components/marketing/MarketingShell";

const LAST_UPDATED = "January 1, 2026";

export default function TermsPage() {
  return (
    <MarketingShell>
      <section className="max-w-3xl mx-auto px-6 py-16 prose-legal">
        <div className="data-label">Legal</div>
        <h1 className="font-display text-4xl font-bold tracking-tight mt-2">Terms of Service</h1>
        <p className="font-mono-data text-xs text-zinc-500 uppercase tracking-widest mt-2">
          Last updated: {LAST_UPDATED}
        </p>

        <Section title="1. Acceptance">
          By accessing or using Lien Scout ("the Service"), operated by Lien Scout
          at lienscoutapp.com, you agree to these Terms of Service. If you don't
          agree, don't use the Service.
        </Section>

        <Section title="2. What we do (and don't do)">
          Lien Scout aggregates <strong>publicly-available</strong> tax-lien and
          tax-sale records from county and municipal sources. We are <strong>not</strong>{" "}
          a licensed real-estate broker, financial advisor, lawyer, or tax
          professional. The AI Deal Score is a heuristic — not a valuation, not
          investment advice, and not a guarantee of any outcome.
        </Section>

        <Section title="3. Accounts and eligibility">
          You must be 18 years or older and legally able to enter into contracts
          in your jurisdiction. You are responsible for keeping your account
          credentials secure. One person per account.
        </Section>

        <Section title="4. Subscriptions and refunds">
          Paid plans auto-renew until cancelled. You can cancel anytime through
          Stripe's customer portal (linked in your account). We honor a 3-day
          free trial — cancel before the trial ends and you're not charged.
          Refunds for paid periods are handled case-by-case; email{" "}
          <a href="mailto:sbrown@lienscoutapp.com">sbrown@lienscoutapp.com</a>.
        </Section>

        <Section title="5. Acceptable use">
          You agree not to (a) scrape or mirror the Service, (b) resell or
          redistribute data as your own product, (c) use the Service to harass
          property owners or violate any law. We may suspend accounts that
          abuse the platform.
        </Section>

        <Section title="6. Data accuracy">
          Public-record data changes constantly. We make best-effort to refresh
          every enabled source every 30 minutes, but sale dates, amounts, and
          statuses may be stale or inaccurate. <strong>Always verify with the
          county before bidding.</strong>
        </Section>

        <Section title="7. Limitation of liability">
          To the maximum extent permitted by law, Lien Scout, its owners,
          employees, and affiliates are not liable for any indirect, incidental,
          special, or consequential damages arising from your use of the
          Service — including lost auction bids, missed deadlines, or property
          valuation errors.
        </Section>

        <Section title="8. Changes to these terms">
          We may update these terms with reasonable notice. Continued use after
          changes means acceptance.
        </Section>

        <Section title="9. Contact">
          Questions? <a href="mailto:sbrown@lienscoutapp.com">sbrown@lienscoutapp.com</a>
        </Section>
      </section>
    </MarketingShell>
  );
}

function Section({ title, children }) {
  return (
    <div className="mt-8">
      <h2 className="font-display text-xl font-bold tracking-tight">{title}</h2>
      <p className="mt-2 text-zinc-700 leading-relaxed text-sm">{children}</p>
    </div>
  );
}
